import { linkEditing } from '@yola/ws-sdk';
import dialogTypes from 'src/js/modules/dialogs/constants/dialog-types';
import errorCodes from 'src/js/modules/extensions/common/constants/error-codes';
import saveFile from './save-file';

const { linkTypes } = linkEditing.constants;

const processLinkSubmit = ({ config }) =>
  new Promise((resolve, reject) => {
    const { linkType, file } = config;
    const { customPath, ...newConfig } = config;

    if (linkType === linkTypes.DOWNLOAD && file) {
      saveFile({
        file,
        customPath,
        dialogName: dialogTypes.UPLOAD_FILE_DIALOG,
        onFileUpload: (result) => {
          newConfig.reference = result.path;
          newConfig.download = result.name;
          delete newConfig.file;
          delete newConfig.customPath;

          resolve(newConfig);
        },
        onUploadCancel: () => {
          reject(errorCodes.UPLOAD_FILE_CANCELED);
        },
        onSaveFileCancel: () => {
          reject(errorCodes.UPLOAD_FILE_CANCELED);
        },
      });
    } else {
      resolve(newConfig);
    }
  });

export default processLinkSubmit;
